import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Layout, Typography, Radio, Input, Button, Tooltip, Space } from 'antd';
import ExpansionManagement from '../../components/ExpansionManagement';
import { organizationActions, periodsActions } from '../../redux/actions/';
import Localization from '../../utils/localization';
import RenderLoader from '../../components/RenderLoader';
import OverlayedLoader from '../../components/OverlayedLoader';

const { Title } = Typography;
const { Content } = Layout;

const GlobalSettings = () => {
    const dispatch = useDispatch();
    const organization = useSelector((state) => state.organization.organization);
    const periods = useSelector((state) => state.periods.periods);
    const expandedPeriods = useSelector((state) => state.periods.expandedPeriods);
    const updatingOrganization = useSelector((state) => state.organization.updatingOrganization);
    const fetchingExpandedPeriods = useSelector((state) => state.periods.fetchingExpandedPeriods);

    const [isExpansionManagementOpen, setIsExpansionManagementOpen] = useState(false);

    useEffect(() => {
        dispatch(organizationActions.getOrganization());
    }, [dispatch]);

    useEffect(() => {
        if (organization != null && periods == null && expandedPeriods == null) {
            dispatch(periodsActions.getPeriods());
            if (!fetchingExpandedPeriods) dispatch(periodsActions.getExpandedPeriods());
        }
    }, [dispatch, organization, periods, fetchingExpandedPeriods, expandedPeriods]);

    const handleUpdateAmountNotation = (e) => {
        const value = e.target.value;
        if (!updatingOrganization){
            dispatch(
                organizationActions.updateOrganization(organization, organization.expanded_periods, value, 'notation'),
            );
        }
    };

    const handleUpdateAmountsSizing = (e) => {
        const value = e.target.value;
        if (!updatingOrganization){
            dispatch(
                organizationActions.updateOrganization(organization, organization.expanded_periods, value, 'amountSizing'),
            );
        }
    };

    const handleUpdateAmountDecimals = (type, nbDecimals) => {
        if (!updatingOrganization){
            dispatch(
                organizationActions.updateOrganization(organization, organization.expanded_periods, nbDecimals, type),
            );
        }
    };

    const renderContent = () => {
        if (!organization) {
            return <RenderLoader />;
        } else {
            return (
                <Layout style={{ height: '100%', marginTop: '0px' }}>
                    {updatingOrganization && <OverlayedLoader />}
                    <Content style={{ margin: '16px 16px 0' }}>
                        <div
                            style={{
                                padding: 24,
                                width: '95%',
                                margin: '0 auto',
                            }}
                        >
                            <Title
                                level={2}
                                style={{
                                    textAlign: 'left',
                                    margin: 0,
                                    marginTop: 30,
                                }}
                            >
                                {Localization.settings.globalSettings}
                            </Title>
                            <Title
                                level={4}
                                style={{
                                    textAlign: 'left',
                                    marginLeft: '40px',
                                }}
                            >
                                {Localization.settings.amountsNotation}
                                <Radio.Group style={{ margin: '1rem' }} onChange={handleUpdateAmountNotation} value={organization.notation}>
                                    <Space direction="vertical">
                                        <Radio value={"American"}>{Localization.settings.american}</Radio>
                                        <Radio value={"European"}>{Localization.settings.european}</Radio>
                                    </Space>
                                </Radio.Group>
                            </Title>
                            <Title
                                level={4}
                                style={{
                                    textAlign: 'left',
                                    marginLeft: '40px',
                                }}
                            >
                                {Localization.settings.amountsSizing}
                                <Radio.Group style={{ margin: '1rem' }} onChange={handleUpdateAmountsSizing} value={organization.amountSizing}>
                                    <Space direction="vertical">
                                        <Radio value={"Units"}>{Localization.settings.units}</Radio>
                                        <Radio value={"Thousands"}>{Localization.settings.thousands}</Radio>
                                        <Radio value={"HundredThousands"}>{Localization.settings.hundredThousands}</Radio>
                                        <Radio value={"Millions"}>{Localization.settings.millions}</Radio>
                                    </Space>
                                </Radio.Group>
                            </Title>
                            <Title
                                level={4}
                                style={{
                                    textAlign: 'left',
                                    marginLeft: '40px',
                                }}
                            >
                                {Localization.settings.amountsDecimals}
                                <Title
                                    level={5}
                                    style={{
                                        textAlign: 'left',
                                        marginLeft: '40px',
                                        display: 'flex'
                                    }}
                                >
                                    {Localization.accountStructure.accountMetricNumeric}
                                    <Input
					                	defaultValue={2}
                                        onChange={(e)=>{handleUpdateAmountDecimals("numericDecimals", parseInt(e.target.value))}}
                                        value={organization.numericDecimals}
                                        style={{ marginLeft: '40px', width: '100px'}}
					                />
                                </Title>
                                <Title
                                    level={5}
                                    style={{
                                        textAlign: 'left',
                                        marginLeft: '40px',
                                        display: 'flex'
                                    }}
                                >
                                    {Localization.accountStructure.accountMetricRatio}
                                    <Input
					                	defaultValue={2}
                                        onChange={(e)=>{handleUpdateAmountDecimals("ratioDecimals", parseInt(e.target.value))}}
                                        value={organization.ratioDecimals}
                                        style={{ marginLeft: '40px', width: '100px'}}
					                />
                                </Title>
                                <Title
                                    level={5}
                                    style={{
                                        textAlign: 'left',
                                        marginLeft: '40px',
                                        display: 'flex'
                                    }}
                                >
                                    {Localization.accountStructure.accountMetricUnit}
                                    <Input
					                	defaultValue={2}
                                        onChange={(e)=>{handleUpdateAmountDecimals("unitDecimals", parseInt(e.target.value))}}
                                        value={organization.unitDecimals}
                                        style={{ marginLeft: '40px', width: '100px'}}
					                />
                                </Title>
                            </Title>
                        </div>
                    </Content>
                </Layout>
            );
        }
    };
    return renderContent();
};
export default GlobalSettings;
